<template>
  <v-dialog v-model="active" content-class="elevation-0" persistent>
    <v-card flat color="transparent">
      <v-container>
        <v-row>
          <v-col class="mx-auto">
            <looping-rhombuses-spinner class="mx-auto" :rhombus-size="80" color="#402DCE" />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { LoopingRhombusesSpinner } from "epic-spinners";
export default {
  props: ["active"], 
  components: {
    LoopingRhombusesSpinner
  }
};
</script>

<style>
.fondo {
  background-color: transparent !important;
  border: 0 transparent !important;
  box-shadow: none !important;
}
</style>